export const floatingActions = {
	massEdit: "Mass edit products",
	editExcel: "Edit via Excel",
	testFiscal: "Test fiscal integration",
	testFiscalData: "Test fiscal data",
	syncWithDelivery: "Sync with delivery",
	deleteSelected: "Delete selected products",
};
